import axios, { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import objectHash from 'object-hash';
import { getMobileAppVersion, isMobileApp } from '../mobile/detectMobile';
import i18n from 'i18next';
import { getWebApplicationVersion } from '../version/appVersionUtil';

export function generateRawErrorCode(critical = false, stacktrace?: string, customErrorType?: string): string {
  const errorCode = stacktrace ? objectHash(stacktrace, { algorithm: 'md5', encoding: 'hex', ignoreUnknown: true }).substring(0, 6).toUpperCase() : nextShortToken();
  const randomCode = nextShortToken();
  const userAgentCode = isMobileApp()
      ? `V${getMobileAppVersion()?.replace(/\s/g, '') || 'MAVUNKW'}`
      : objectHash(window?.navigator?.userAgent, { algorithm: 'md5', encoding: 'hex', ignoreUnknown: true })?.substring(0, 6)?.toUpperCase() || 'UAUNKW';
  const pathCode = objectHash(window?.location?.href, { algorithm: 'md5', encoding: 'hex', ignoreUnknown: true })?.substring(0, 6)?.toUpperCase() || 'PAUNKW';
  const errorPrefix = critical ? 'C' : '';
  const mobilePrefix = isMobileApp() ? 'M' : '';
  const errorSuffix = customErrorType ?? 'JS';
  return `${mobilePrefix}${errorPrefix}${errorSuffix}.${errorCode}.${randomCode}.${currentTimeString()}.${userAgentCode}.${pathCode}`;
}

function nextShortToken(): string {
  return Math.random().toString(36).substring(2, 8).toUpperCase();
}

function currentTimeString(): string {
  return DateTime.utc().toFormat('yyyyMMddHHmmss');
}

export function generateCommonErrorCode(code: string): string {
  return `${code}.${currentTimeString()}`;
}

export interface JsError {
  name: string;
  message: string;
  source: string;
  stack: string;
  code: string;
  userAgent: string;
  userAgentLang: string;
  lang: string;
  path: string;
  innerWidthHeight: string;
}

export function postJsError(jsError: JsError): Promise<AxiosResponse<void>> {
  return axios.post('error/js-errors',
      ({...jsError,
        webApplicationVersion: getWebApplicationVersion(),
        mobileApplicationVersion: getMobileAppVersion() ?? null,
      }));
}

export const getCurrentLanguage = () => i18n.language || 'pl';
